import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// Only the preset ids, so the route tree that loads when the app starts does
// not pull in the playground's screen or its cards
import { PLAYGROUND_PRESET_IDS } from '@/features/meetings/assist/playground/meeting-assist-playground.preset-ids';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute(
  '/_authenticated/playground/meeting-assist'
)({
  beforeLoad() {
    if (userStore.isInternalUser) return;

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  validateSearch: z.object({
    preset: z.enum(PLAYGROUND_PRESET_IDS).optional().catch(undefined),
  }).parse,
});
